import React from "react";
import axios from "axios";
export function useFetch(url: string): any {
  const [data, setData] = React.useState<null | object>(null);

  React.useEffect(() => {
    if (!url) return;
    let cancelled = false;
    axios
      .get(url)
      .then((response) => {
        if (!cancelled) setData(response.data);
      })
      .catch((e) => {
        if (!cancelled) setData({ error: e?.message || String(e) });
      });
    return () => {
      cancelled = true;
    };
  }, [url]);
  return data;
}
